import { observer } from "mobx-react-lite"
import { useProposalsEditDetailsStore } from "./ProposalsEditDetailsStore"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import GapButtonTooltip from "features/gap-components/tooltip/GapButtonTooltip"
import GapAutocompleteMultiple from "features/gap-components/autocomplete/multiple/GapAutocompleteMultiple"

export default observer(function ProposalsEditDetailsExpectations() {
   const proposalsEditDetailsStore = useProposalsEditDetailsStore()

   return <>
      <Typography variant="subtitle1">Set your expectations</Typography>
      <Typography variant="caption">Set the expectations with your client upfront to establish a great relationship right from the start.</Typography>

      <Box sx={{ pt: 2, pb: 1, textAlign: 'right' }}>
         <GapButtonTooltip buttonText='Why these expectations?' tooltip='These expectations are suitable for any proposal.' />
      </Box>
      {proposalsEditDetailsStore.expectationOptions.length > 0 && proposalsEditDetailsStore.formHandler.expectations.bindInput(ip =>
         <GapAutocompleteMultiple
            {...ip}
            options={proposalsEditDetailsStore.expectationOptions}
            disableCloseOnSelect
            label='Choose up to 5 expectations'
         />
      )}
   </>
})

